<template>
  <div>Workforce Analysis</div>
</template>

<script>
export default {
  name: "c_workforce_analysis"
}
</script>

<style scoped>

</style>
